import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CallbackFormService, FormPayload } from '../../../shared-services/callback-form/callback-form.service';
import { CallbackFormInterface } from '../../../interfaces/callback-form-interface';

@Component({
  selector: 'app-callback-form',
  templateUrl: './callback-form.component.html',
  styleUrl: './callback-form.component.scss'
})
export class CallbackFormComponent {
  @Input() showCallbackForm = false;
  @Output() showCallbackFormChange = new EventEmitter<boolean>();
  FORM_CODE = 'quality_question'
  isSubmitted = false
  formSubmitted = false
  contactForm = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.minLength(3)]),
    phone: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    message: new FormControl('', [Validators.required, Validators.minLength(12)]),
    code: new FormControl(this.FORM_CODE)
  });

  constructor(private CallbackFormService: CallbackFormService) {}

  get name() {return this.contactForm.get('name')}
  get phone() {return this.contactForm.get('phone')}
  get email() {return this.contactForm.get('email')}
  get message() {return this.contactForm.get('message')}


  hasError(field: string, validationType: string): boolean {
    const control = this.contactForm.get(field);
    return !!(control?.hasError(validationType) && control?.touched);
  }

  onSubmit() {
    if (this.contactForm.valid) {
      if (this.isSubmitted) return;
      this.isSubmitted = true;

      this.CallbackFormService.processForm(this.contactForm.value as FormPayload)
        .subscribe((response: CallbackFormInterface) => {
          if (response.status === 'success') {
            this.formSubmitted = true;
            this.isSubmitted = false;
            this.contactForm.reset();
            this.contactForm.controls.code.patchValue(this.FORM_CODE);
          }
        })
    } else {
      this.contactForm.markAllAsTouched();
      console.log('Форма не валидна')
    }
  }

  onClose() {
    this.showCallbackForm = false
    this.formSubmitted = false
    // Уведомляем родителя
    this.showCallbackFormChange.emit(this.showCallbackForm);
  }

  onOverlayClick(event: MouseEvent): void {

    const target = event.target as HTMLElement;
    const isOverlayClicked = target.classList.contains('fancybox-slide');

    if (isOverlayClicked) {
      this.showCallbackForm = false;
      // Уведомляем родителя
      this.showCallbackFormChange.emit(this.showCallbackForm);
    }
  }
}
